import React from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  makeStyles
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  itemFamilyImage: {
    width: '100%',
    paddingBottom: '72.5%',
    position: 'relative',
    '& img': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      objectFit: 'contain'
    }
  }
}));

const MainImage = props => {
  const classes = useStyles();

  const { src } = props;

  return (
    <Box mb={1} className={classes.itemFamilyImage}>
      {src ? <img src={src} alt=""/> : null}
    </Box>
  );
};

MainImage.propTypes = {
  src: PropTypes.string
};

export default MainImage;
